import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

interface StatusFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
  isResourceSharingEnabled?: boolean;
}

export const StatusFilter = ({ onChange, selectedValue, isResourceSharingEnabled = false }: StatusFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const statusOptions = isResourceSharingEnabled
    ? [
        { value: 'all', text: intl.formatMessage({ id: 'predict.filters.status.all', defaultMessage: 'All' }) },
        {
          value: 'performanceDashboard',
          text: intl.formatMessage({
            id: 'predict.dashboards.status.performance_dashboard',
            defaultMessage: 'Performance dashboard'
          })
        },
        { value: 'shared', text: intl.formatMessage({ id: 'common.shared', defaultMessage: 'Shared' }) },
        { value: 'private', text: intl.formatMessage({ id: 'common.private', defaultMessage: 'Private' }) }
      ]
    : [
        { value: 'all', text: intl.formatMessage({ id: 'predict.filters.status.all', defaultMessage: 'All' }) },
        {
          value: 'live',
          text: intl.formatMessage({ id: 'predict.dashboards.filters.status.live', defaultMessage: 'Live' })
        },
        { value: 'draft', text: intl.formatMessage({ id: 'predict.filters.status.draft', defaultMessage: 'Draft' }) },
        {
          value: 'performanceDashboard',
          text: intl.formatMessage({
            id: 'predict.dashboards.status.performance_dashboard',
            defaultMessage: 'Performance dashboard'
          })
        }
      ];

  return (
    <Box width={250}>
      <SimpleSelect
        label={
          isResourceSharingEnabled
            ? intl.formatMessage({ id: 'common.sharing', defaultMessage: 'Sharing' })
            : intl.formatMessage({ id: 'common.status', defaultMessage: 'Status' })
        }
        value={selectedValue}
        onChange={handleChange}
      >
        {statusOptions.map(option => (
          <Option key={option.value} value={option.value} text={option.text} />
        ))}
      </SimpleSelect>
    </Box>
  );
};
